import { render, staticRenderFns } from "./ConTents.vue?vue&type=template&id=06d596dd&scoped=true"
import script from "./ConTents.vue?vue&type=script&lang=js"
export * from "./ConTents.vue?vue&type=script&lang=js"
import style0 from "./ConTents.vue?vue&type=style&index=0&id=06d596dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d596dd",
  null
  
)

export default component.exports